// extracted by mini-css-extract-plugin
export var cardLayout = "_84-1";
export var paginationContainer = "_84-0";